<!--
Es muss eine Faserdicke angegeben werden. Diese wird entweder in Pixel oder in eine vom Benutzer definierte Einheit eingegeben. (Bspw. Nanometer (NM))

Wird eine andere Einheit gewählt, muss zurätzlich die Umrechnung in PX angegeben werden

1 NM = 1 PX

Dann muss Fiber diameter immer umgerechnet werden

Die Werte aus dem Standard Parameterset müssen dann immer in PX umgerechnet werden

1 FD = 4 nm

4nm = 8 px

Danach muss das parameter set ausgewählt werden. Sind beide (oder alle drei bei abweichender Einheit) werte befüllt, kann erst der advanced trigger ausgeführt werden. Darauf sollen alle Werte berechnet werden

also

set_scale 1 fiber_diameter = 4 pixel
sigma_smooth 0.5
sigma_conv 0.45 * 4 (px)
r_min 0 * 4 (px)
r_max 2 * 4 (px)

-->

<template>
    
    <div class="content">

    <div class="form-row">


        <div class="form-group col-md-12">
            <label>Name</label>
            <input type="text" class="form-control" :class="
                            form.errors.name ? 'is-invalid' : ''
                        " name="set_scale_value" v-model="form.name" />
            <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors.name">
                {{ error }}
            </span>
        </div>
        </div>

        <div class="form-row">

            
            <div class="form-group col-md-6">
            <label>Set fiber diameter value / unit</label>
            <div class="input-group">
                <input type="number" class="form-control" :class="
                            form.errors.fiber_diameter_value ? 'is-invalid' : ''
                        " :disabled="showFiberdiameter" name="set_scale_value" v-model="form.fiber_diameter_value" />

                <select v-model="form.chooseUnit" class="form-control" aria-label=".form-select-lg example">
                    <option value="px" selected>px</option>
                    <option value="unit" v-if="form.set_scale">{{ form.fiber_diameter_unit }}</option>
                </select>
            </div>

            <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors.fiber_diameter_value">
                {{ error }}
            </span>
            <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors.fiber_diameter_unit">
                {{ error }}
            </span>
        </div>

        
        
        <div class="col-md-6">
        <div class="form-group">
            <label>tools </label><br>
            <button type="button" class="btn btn-primary" @click="showFiberdiameter = !showFiberdiameter">
                <span v-if="!showFiberdiameter">Graphical diameter calculation</span>
                <span v-else>manual input</span>
            </button>
        </div>
        </div>
        </div>
         <div class="col-md-12">
                <fiberdiameter :form="form" v-show="showFiberdiameter" />

            </div>

        <div class="form-row">
        <div class="form-group col-md-12">
    
                <div class="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        :class="
                            form.errors.set_scale ? 'is-invalid' : ''
                        "
                        id="save_tracing_data"
                        v-model="form.set_scale"
                    />
                    <label
                        class="custom-control-label"
                        for="save_tracing_data"
                        >set scale</label
                    >
                </div>
        </div>
        

            <div class="form-group col-md-12" v-if="form.set_scale">
                <label>set scale value and unit</label>

                <div class="input-group">
                    <input type="number" class="form-control" :class="form.errors.set_scale_value ? 'is-invalid' : ''" name="set_scale_value" v-model="form.set_scale_value" :disabled="showFiberdiameter" />
                    <div class="input-group-append">
                        <input type="text" class="form-control" :class="form.errors.fiber_diameter_unit ? 'is-invalid' : ''" name="set_scale_value" v-model="form.fiber_diameter_unit" :disabled="showFiberdiameter">

                        </button>
                    </div>

                    <div class="input-group-prepend">
                        <button type="button" class="btn btn-grey">
                            =
                        </button>
                    </div>

                    <input type="number" class="form-control input-group-append" name="set_scale_unit" :class="form.errors.set_scale_px ? 'is-invalid' : ''" v-model="form.set_scale_px" :disabled="showFiberdiameter" />

                    <div class="input-group-append">
                        <button type="button" class="btn btn-secondary">
                            px
                        </button>
                    </div>

                </div>
                <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors.set_scale_value">
                    {{ error }}
                </span>
                <span class="help-block text-danger" :key="index" v-for="(error, index) in form.errors.set_scale_unit">
                    {{ error }}
                </span>
            </div>
            </div>
           
            <div class="form-row">
            <div class="col-md-12">
                <label>Choose Preset</label>
                <select v-model="form.preset" class="form-control form-control-lg" aria-label=".form-select-lg example">
                    <option value="default" selected>Default</option>
                    <option value="low">Low</option>
                    <option value="high">High</option>
                </select>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import fiberdiameter from "./fiberdiameter.vue";

export default {
    props: ["form", "advanced"],
    components: {
        fiberdiameter: fiberdiameter
    },
    data: function () {
        return {
            showFiberdiameter: false,
            presets: {
                default: {
                    //set_scale: '1 fiber_diameter = 4 pixel:', //
                    sigma_smooth: 0.5, // >0
                    sigma_conv: 0.45, // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    r_min: 0, // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei px nicht multiplizieren, fiber diameter fiber_diameter_value
                    r_max: 2, // > r_min // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    steps: 100, // >0 INTEGER
                    thresh: 2, // beliebig
                    r_step: "0.75", // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    min_loop_length: 7 // > 1 INTEGER
                },
                high: {
                    //set_scale: '1 fiber_diameter = 4 pixel:', //
                    sigma_smooth: 0.55, // >0
                    sigma_conv: 0.45, // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    r_min: 0, // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    r_max: 2, // > r_min // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    steps: 100, // >0 INTEGER
                    thresh: 2.5, // beliebig
                    r_step: 0.75, // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    min_loop_length: 7 // > 1 INTEGER
                },
                low: {
                    //set_scale: '1 fiber_diameter = 4 pixel:', //
                    sigma_smooth: 0.45, // >0
                    sigma_conv: 0.45, // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    r_min: 0, // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    r_max: 2, // > r_min // >=0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    steps: 100, // >0 INTEGER
                    thresh: 1.5, // beliebig
                    r_step: 0.75, // >0 multipliziert mit entweder set_scale_divided bei auswahl set_scale_unit, bei bx nicht multiplizieren, fiber diameter fiber_diameter_value
                    min_loop_length: 7 // > 1 INTEGER
                }
            },
            unitPx: true
        };
    },
    computed: {
        unit() {
            return this.form.chooseUnit;
        },
        presetWatcher() {
            return (
                this.form.fiber_diameter_unit +
                this.form.fiber_diameter_value +
                this.form.set_scale_value +
                this.form.set_scale_px +
                this.form.preset+
                this.form.chooseUnit
            );
        }
    },
    watch: {
        unit() {
            var unit = this.unit.toLowerCase();
            if (unit == "px" || unit == "pixel" || unit == "pixels") {
                this.unitPx = true;
            } else {
                this.unitPx = false;
            }
        },
        presetWatcher() {
            this.calculateForm();
        }
    },
    methods: {
        calculateForm() {
            var fiber_diameter_px = this.form.chooseUnit=='px' ?
                this.form.fiber_diameter_value :
                (this.form.fiber_diameter_value * this.form.set_scale_px) /
                this.form.set_scale_value;
            console.log(fiber_diameter_px);
            this.form.sigma_smooth = this.presets[
                this.form.preset
            ].sigma_smooth; // >0
            this.form.sigma_conv =
                Math.round(
                    (this.presets[this.form.preset].sigma_conv *
                    fiber_diameter_px) *
                    100
                ) / 100;
            this.form.delete_worst_sections_value = 2*this.form.sigma_conv;
            this.form.r_min =
                Math.round(
                    (this.presets[this.form.preset].r_min *
                    fiber_diameter_px) *
                    100
                ) / 100;
            this.form.r_max =
                Math.round(
                    (this.presets[this.form.preset].r_max *
                    fiber_diameter_px )*
                    100
                ) / 100;
            this.form.steps = this.presets[this.form.preset].steps;
            this.form.thresh = this.presets[this.form.preset].thresh;
            this.form.r_step =
                Math.round((
                    this.presets[this.form.preset].r_step *
                    fiber_diameter_px )*
                    100
                ) / 100;
            this.form.min_loop_length = this.presets[
                this.form.preset
            ].min_loop_length;
        }
    }
};
</script>
